import React from 'react'

const TermsPage = () => {
  return (
    <div className="font-['Inter'] min-h-screen bg-white text-[#0F172A]">
      {/* Header */}
      <header className="w-full flex items-center justify-between px-6 py-4 border-b border-gray-100">
        <div className="flex items-center gap-2">
          <div className="text-2xl font-black tracking-tighter text-[#0F172A]">
            UGC<span className="text-[#1D8BF8]">4you</span>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-4xl font-black mb-8 bg-gradient-to-r from-[#1D8BF8] to-[#7c3aed] bg-clip-text text-transparent">
          Algemene Voorwaarden
        </h1>

        <div className="prose max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">1. AANVAARDING VAN DE SERVICEVOORWAARDEN</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>1.1</strong> UGC4you, UGC4you VOF (hierna te noemen UGC4you, wij, ons of onze) is eigenaar en beheert bepaalde websites, waaronder https://ugc4you.nl (gezamenlijk, het "UGC4you Platform") en biedt User-Generated Content marketplace diensten aan (de "UGC4you-diensten"). Het gebruik van de UGC4you-diensten en het UGC4you Platform is onderworpen aan de meest recente versie van de algemene voorwaarden die zijn opgenomen in deze Overeenkomst, zoals van tijd tot tijd gewijzigd (de "Overeenkomst"). Door toegang te verkrijgen, een account aan te maken, te browsen of anderszins gebruik te maken van de UGC4you-diensten, erkent u dat u deze Overeenkomst heeft gelezen, begrepen en ermee instemt gebonden te zijn.
              </p>

              <p>
                <strong>1.2</strong> Deze Overeenkomst stelt de volledige overeenstemming tussen partijen vast. UGC4you behoudt zich het recht voor om deze voorwaarden te wijzigen. Wijzigingen worden minimaal 30 dagen van tevoren aangekondigd via email en op het platform. Voortgezet gebruik na wijzigingen betekent aanvaarding van de nieuwe voorwaarden.
              </p>

              <p>
                <strong>1.3</strong> <strong>Leeftijdsvereisten</strong><br />
                Het UGC4you Platform is uitsluitend beschikbaar voor personen van 18 jaar en ouder. Door gebruik te maken van onze diensten bevestigt u dat u minimaal 18 jaar oud bent en de wettelijke bevoegdheid heeft om deze overeenkomst aan te gaan.
              </p>

              <p>
                <strong>1.4</strong> <strong>Aanvullende voorwaarden</strong><br />
                Naast deze voorwaarden bent u gebonden aan ons Privacybeleid, Cookie Policy en eventuele specifieke servicevoorwaarden die van toepassing zijn op bepaalde functies van het platform.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">2. INLEIDING</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>2.1</strong> Het doel van het UGC4you Platform is om bedrijven of kopers ("Merken of Brands") te verbinden met de gebruikersgemeenschap op social media ("Makers of Creators") en social media marketing, door gebruikers gegenereerde inhoud en andere taken mogelijk te maken: het creëren en beheren van relaties, het organiseren van weggeefacties voor producten/diensten, het mogelijk maken van de aankoop en verspreiding van door gebruikers gegenereerde inhoud op social media.
              </p>

              <p>
                <strong>2.2</strong> UGC4you hanteert een transparant en eerlijk commissiemodel waarbij creators <strong>85% van de projectwaarde ontvangen</strong> en UGC4you slechts 15% als platform fee rekent. Dit staat in contrast tot andere platformen die vaak 30-50% commissie rekenen.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">3. GEBRUIK VAN HET UGC4YOU PLATFORM</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>3.1</strong> Het UGC4you Platform stelt Merken in staat om verbinding te maken met de gebruikersgemeenschap op social media en/of door gebruikers gegenereerde content aan te kopen, met als doel het verwerven van video- en audiobestanden van Makers, die specifiek voor het Merk zijn gemaakt ("Content of Inhoud").
              </p>

              <p>
                <strong>3.2</strong> <strong>Transparante Prijsstructuur</strong><br />
                UGC4you hanteert een transparante prijsstructuur voor UGC video's:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>15 seconden video: €64 (€15 goedkoper dan concurrenten)</li>
                <li>30 seconden video: €84 (€15 goedkoper dan concurrenten)</li>
                <li>60 seconden video: €104 (€15 goedkoper dan concurrenten)</li>
              </ul>

              <p>
                <strong>3.3</strong> Het relevante Merk is uitsluitend verantwoordelijk voor het verstrekken van een nauwkeurige, uitvoerbare en uitgebreide beschrijving van de vereisten voor de Content ("Taakbrief") aan de Maker en het tijdig betalen voor Inhoud die is geüpload naar het UGC4you Platform.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">4. VOORWAARDEN VOOR CREATORS</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>4.1</strong> <strong>Eligibiliteit van Creators</strong><br />
                Om een Creator Account op het UGC4you Platform te registreren, moet de persoon 18 jaar of ouder zijn.
              </p>

              <p>
                <strong>4.2</strong> <strong>Vergoeding voor Creators</strong><br />
                Creators worden gecompenseerd voor de Content die ze maken nadat de Content is geüpload naar het UGC4you Platform en geaccepteerd door Brand. <strong>Creators ontvangen 85% van de projectwaarde</strong>, wat aanzienlijk hoger is dan bij andere platformen.
              </p>

              <p>
                <strong>4.3</strong> <strong>Snelle Uitbetaling</strong><br />
                UGC4you garandeert uitbetaling binnen 48 uur na goedkeuring van de content, in tegenstelling tot de standaard 7-14 dagen bij andere platformen.
              </p>

              <p>
                <strong>4.4</strong> <strong>Volume Kortingen</strong><br />
                Bij bestelling van 5 video's krijgt de klant de 5e video gratis. Deze korting wordt doorberekend zonder invloed op de creator vergoeding.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">5. BETALINGSVOORWAARDEN EN ESCROW SYSTEEM</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>5.1</strong> <strong>Betalingsstructuur</strong><br />
                UGC4you hanteert een two-stage betalingssysteem:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Aanbetaling (10%):</strong> Betaalbaar zodra je een voorstel van een creator accepteert</li>
                <li><strong>Eindafrekening (90%):</strong> Betaalbaar na goedkeuring van de geleverde content</li>
              </ul>

              <p>
                <strong>5.2</strong> <strong>Geaccepteerde Betaalmethoden</strong><br />
                Betalingen worden verwerkt via Stripe en ondersteunen de volgende methoden:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Creditcards (Visa, Mastercard, American Express)</li>
                <li>iDEAL (Nederlandse banken)</li>
                <li>Alle andere door Stripe ondersteunde betaalmethoden in uw regio</li>
              </ul>

              <p>
                <strong>5.3</strong> <strong>Escrow Systeem</strong><br />
                UGC4you gebruikt een veilig escrow systeem:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Betalingen worden veilig bewaard totdat alle voorwaarden zijn vervuld</li>
                <li>Na eindafrekening wordt er een <strong>7-dagen geschillenperiode</strong> gehanteerd</li>
                <li>Na deze periode worden fondsen automatisch vrijgegeven aan de creator</li>
                <li>Bij geschillen worden fondsen vastgehouden tot oplossing</li>
              </ul>

              <p>
                <strong>5.4</strong> <strong>Transparante Kostenverdeling</strong><br />
                Van elke betaling gaat <strong>85% naar de creator</strong> en <strong>15% naar UGC4you</strong> als platform fee. Deze verdeling wordt transparant getoond in de prijscalculator en is lager dan bij vergelijkbare platformen.
              </p>

              <p>
                <strong>5.5</strong> <strong>Terugbetalingen</strong><br />
                Terugbetalingen zijn mogelijk onder de volgende omstandigheden:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Creator levert geen content binnen afgesproken termijn (volledige terugbetaling)</li>
                <li>Content voldoet niet aan specificaties na herhaalde correctieverzoeken</li>
                <li>Technische problemen aan onze kant (volledige terugbetaling)</li>
                <li>Terugbetalingen worden binnen 5-10 werkdagen verwerkt</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">6. INTELLECTUELE EIGENDOMSRECHTEN</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>6.1</strong> Alle recht, titel en belang in alle Intellectuele Eigendomsrechten in de gecreëerde Content wordt overgedragen aan het Merk, inclusief alle commerciële gebruiksrechten.
              </p>

              <p>
                <strong>6.2</strong> Het Merk verwerft volledige rechten op de content en kan deze gebruiken voor alle marketingdoeleinden, sociale media, advertenties en andere commerciële activiteiten.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">7. AANSPRAKELIJKHEID EN GARANTIES</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>7.1</strong> <strong>Service Level Guarantees</strong><br />
                UGC4you garandeert:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>99% platform uptime (exclusief geplande onderhoud)</li>
                <li>Veilige opslag van alle geüploade content</li>
                <li>Tijdige verwerking van betalingen via Stripe</li>
                <li>24/7 technische ondersteuning voor kritieke problemen</li>
              </ul>

              <p>
                <strong>7.2</strong> <strong>Beperking van Aansprakelijkheid</strong><br />
                De aansprakelijkheid van UGC4you is beperkt tot:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Maximum het bedrag dat betaald is voor het betreffende project</li>
                <li>Uitsluitend directe schade, geen gevolgschade</li>
                <li>Geen aansprakelijkheid voor gedrag van creators of brands</li>
                <li>Geen aansprakelijkheid voor verlies van winst of inkomsten</li>
                <li>Geen aansprakelijkheid voor kwaliteit van content (dit is tussen partijen)</li>
              </ul>

              <p>
                <strong>7.3</strong> <strong>Uitgesloten Aansprakelijkheid</strong><br />
                UGC4you is niet aansprakelijk voor:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Schade door force majeure omstandigheden</li>
                <li>Verlies van gegevens door gebruikersfouten</li>
                <li>Schendingen van intellectuele eigendomsrechten door gebruikers</li>
                <li>Handelingen van derden (hackers, etc.)</li>
                <li>Problemen met betalingsproviders buiten onze controle</li>
              </ul>

              <p>
                <strong>7.4</strong> <strong>Vrijwaring</strong><br />
                Gebruikers vrijwaren UGC4you van alle claims die voortvloeien uit:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Schending van deze voorwaarden door de gebruiker</li>
                <li>Inbreuk op rechten van derden door geüploade content</li>
                <li>Onjuiste of misleidende informatie verstrekt door gebruiker</li>
                <li>Illegale activiteiten via het platform</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">8. GDPR EN PRIVACY COMPLIANCE</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>8.1</strong> <strong>Gegevensbescherming</strong><br />
                UGC4you houdt zich strikt aan de Algemene Verordening Gegevensbescherming (GDPR) en Nederlandse privacywetgeving. Wij fungeren als verwerkingsverantwoordelijke voor uw persoonlijke gegevens.
              </p>

              <p>
                <strong>8.2</strong> <strong>Verzamelde Gegevens</strong><br />
                Wij verzamelen uitsluitend noodzakelijke gegevens:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Accountinformatie (naam, email, bedrijfsgegevens)</li>
                <li>Projectgegevens en communicatie via het platform</li>
                <li>Betalingsgegevens (verwerkt via Stripe - wij slaan geen creditcardgegevens op)</li>
                <li>Technische gegevens (IP-adres, browser type, gebruik statistics)</li>
              </ul>

              <p>
                <strong>8.3</strong> <strong>Uw Rechten</strong><br />
                U heeft de volgende rechten betreffende uw persoonlijke gegevens:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Recht op inzage:</strong> Opvragen welke gegevens wij van u hebben</li>
                <li><strong>Recht op rectificatie:</strong> Correctie van onjuiste gegevens</li>
                <li><strong>Recht op verwijdering:</strong> Verzoek tot verwijdering van uw gegevens</li>
                <li><strong>Recht op beperking:</strong> Beperking van verwerking</li>
                <li><strong>Recht op overdraagbaarheid:</strong> Export van uw gegevens</li>
                <li><strong>Recht van bezwaar:</strong> Bezwaar tegen verwerking</li>
              </ul>

              <p>
                <strong>8.4</strong> <strong>Gegevensbeveiliging</strong><br />
                Wij implementeren passende technische en organisatorische maatregelen:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>SSL/TLS encryptie voor alle gegevensverzending</li>
                <li>Gehashte wachtwoorden (bcrypt)</li>
                <li>JWT tokens voor veilige authenticatie</li>
                <li>Regelmatige security updates en monitoring</li>
                <li>Toegangsbeperking op need-to-know basis</li>
              </ul>

              <p>
                <strong>8.5</strong> <strong>Gegevens Delen</strong><br />
                Wij delen uw gegevens uitsluitend:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Tussen creators en brands voor projectcommunicatie (geanonimiseerd waar mogelijk)</li>
                <li>Met Stripe voor betalingsverwerking (conform hun privacy policy)</li>
                <li>Bij wettelijke verplichting of gerechtelijk bevel</li>
                <li>Nooit voor commerciële doeleinden aan derden</li>
              </ul>

              <p>
                <strong>8.6</strong> <strong>Bewaartermijnen</strong><br />
                Wij bewaren uw gegevens niet langer dan noodzakelijk:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Accountgegevens: tot 2 jaar na account deactivatie</li>
                <li>Projectgegevens: tot 7 jaar (fiscale bewaarplicht)</li>
                <li>Communicatiegegevens: tot 3 jaar na projectafronding</li>
                <li>Technische logs: maximaal 1 jaar</li>
              </ul>

              <p>
                <strong>8.7</strong> <strong>Contact Gegevensbescherming</strong><br />
                Voor alle privacy-gerelateerde vragen of verzoeken: <strong>privacy@ugc4you.nl</strong>
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">9. GESCHILLENPROTOCOL EN OPLOSSING</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>9.1</strong> <strong>Geschillenpreventie</strong><br />
                UGC4you streeft naar proactieve geschillenpreventie door:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Duidelijke projectspecificaties en verwachtingen</li>
                <li>Transparante communicatie via het platform</li>
                <li>Tijdige feedback en goedkeuringsprocessen</li>
                <li>Proactieve support bij problemen</li>
              </ul>

              <p>
                <strong>9.2</strong> <strong>Geschillenresolutie Proces</strong><br />
                Bij geschillen hanteren wij het volgende proces:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Fase 1:</strong> Direct contact tussen partijen via platform messaging</li>
                <li><strong>Fase 2:</strong> Mediatie door UGC4you support team (binnen 48 uur)</li>
                <li><strong>Fase 3:</strong> Formeel geschil procedure met bewijsvoering</li>
                <li><strong>Fase 4:</strong> Beslissing door UGC4you binnen 5 werkdagen</li>
                <li><strong>Fase 5:</strong> Beroep mogelijk binnen 14 dagen</li>
              </ul>

              <p>
                <strong>9.3</strong> <strong>Escrow Bescherming Tijdens Geschillen</strong><br />
                Tijdens geschilprocedures:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Betalingen worden veilig vastgehouden in escrow</li>
                <li>Geen uitbetaling totdat geschil is opgelost</li>
                <li>Bewijs moet worden overlegd binnen 7 dagen</li>
                <li>Partijen krijgen gelijke mogelijkheid tot verweer</li>
              </ul>

              <p>
                <strong>9.4</strong> <strong>Mogelijke Uitkomsten</strong><br />
                Geschillenresolutie kan resulteren in:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Volledige uitbetaling aan creator (bij onterechte klacht)</li>
                <li>Volledige terugbetaling aan brand (bij niet-levering)</li>
                <li>Gedeeltelijke terugbetaling bij partiële levering</li>
                <li>Opdracht tot herwerking met aangepaste deadline</li>
                <li>Compensatie voor extra kosten bij beide partijen</li>
              </ul>

              <p>
                <strong>9.5</strong> <strong>Juridische Geschillen</strong><br />
                Voor geschillen die niet intern opgelost kunnen worden:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Nederlandse wetgeving is van toepassing</li>
                <li>Bevoegde rechtbank: District Court Rotterdam</li>
                <li>Partijen worden aangemoedigd om eerst mediation te proberen</li>
                <li>UGC4you behoudt zich het recht voor om accounts te suspenderen bij misbruik</li>
              </ul>

              <p>
                <strong>9.6</strong> <strong>Support Contact</strong><br />
                Voor alle geschillen en klachten: <strong>support@ugc4you.nl</strong><br />
                Verwachte responstijd: binnen 24 uur op werkdagen.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">10. FORCE MAJEURE EN ONDERBREKING VAN DIENSTEN</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>10.1</strong> <strong>Force Majeure</strong><br />
                UGC4you is niet aansprakelijk voor vertragingen of het niet nakomen van verplichtingen als gevolg van omstandigheden buiten onze redelijke controle, waaronder:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Natuurrampen, epidemieën, pandemieën</li>
                <li>Terrorisme, oorlog, burgerlijke onrust</li>
                <li>Internetuitval, cyberaanvallen op grote schaal</li>
                <li>Uitval van essentiële diensten (Stripe, AWS, etc.)</li>
                <li>Wijzigingen in wet- of regelgeving</li>
              </ul>

              <p>
                <strong>10.2</strong> <strong>Geplande Onderhoud</strong><br />
                UGC4you kan het platform tijdelijk offline halen voor onderhoud. Wij streven ernaar om:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Minimaal 24 uur van tevoren te waarschuwen</li>
                <li>Onderhoud buiten kantooruren uit te voeren</li>
                <li>Onderbreking tot maximum 4 uur te beperken</li>
                <li>Kritieke functies zo snel mogelijk te herstellen</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">11. ACCOUNT BEËINDIGING EN OPSCHORTING</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>11.1</strong> <strong>Vrijwillige Beëindiging</strong><br />
                U kunt uw account op elk moment beëindigen door:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Contact op te nemen met support@ugc4you.nl</li>
                <li>Alle openstaande projecten af te ronden</li>
                <li>Eventuele tegoedens op te nemen</li>
                <li>Account wordt binnen 30 dagen gesloten</li>
              </ul>

              <p>
                <strong>11.2</strong> <strong>Beëindiging door UGC4you</strong><br />
                Wij kunnen accounts opschorten of beëindigen bij:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Herhaaldelijke schending van deze voorwaarden</li>
                <li>Frauduleuze activiteiten of misbruik van het platform</li>
                <li>Niet-betaling van verschuldigde bedragen</li>
                <li>Illegale activiteiten of content</li>
                <li>Schade aan de reputatie van het platform</li>
              </ul>

              <p>
                <strong>11.3</strong> <strong>Gevolgen van Beëindiging</strong><br />
                Bij accountbeëindiging:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Toegang tot het platform wordt onmiddellijk beëindigd</li>
                <li>Lopende projecten worden afgehandeld conform escrow regels</li>
                <li>Persoonlijke gegevens worden conform privacy policy verwerkt</li>
                <li>Uitstaande betalingen worden binnen 30 dagen verwerkt</li>
                <li>Intellectuele eigendomsrechten blijven bij rechthebbenden</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">12. WIJZIGINGEN EN UPDATES</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>12.1</strong> <strong>Platform Updates</strong><br />
                UGC4you behoudt zich het recht voor om het platform te wijzigen, inclusief:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Toevoeging van nieuwe functies en services</li>
                <li>Verbetering van bestaande functionaliteit</li>
                <li>Wijziging van gebruikersinterface</li>
                <li>Security updates en bugfixes</li>
              </ul>

              <p>
                <strong>12.2</strong> <strong>Prijswijzigingen</strong><br />
                Wijzigingen in prijzen of commissiestructuur:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Worden minimaal 60 dagen van tevoren aangekondigd</li>
                <li>Gelden niet voor reeds lopende projecten</li>
                <li>Geven gebruikers het recht om account te beëindigen</li>
                <li>Worden gepubliceerd op het platform en via email</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">13. CONTACT EN BEDRIJFSGEGEVENS</h2>

            <div className="space-y-4 text-[#0F172A]">
              <div className="bg-[#F8FAFC] rounded-lg p-6 border border-gray-200">
                <p><strong>Bedrijfsnaam:</strong> UGC4you VOF</p>
                <p><strong>Website:</strong> https://ugc4you.nl</p>
                <p><strong>Algemene vragen:</strong> info@ugc4you.nl</p>
                <p><strong>Technische support:</strong> support@ugc4you.nl</p>
                <p><strong>Privacy vragen:</strong> privacy@ugc4you.nl</p>
                <p><strong>Juridische zaken:</strong> legal@ugc4you.nl</p>
                <p><strong>KvK registratie:</strong> [Nog in te vullen]</p>
                <p><strong>BTW nummer:</strong> [Nog in te vullen]</p>
                <p><strong>Land van vestiging:</strong> Nederland</p>
              </div>

              <p className="mt-4">
                <strong>Responstijden:</strong><br />
                - Algemene vragen: binnen 48 uur<br />
                - Technische problemen: binnen 24 uur<br />
                - Urgente zaken: binnen 4 uur (werkdagen)<br />
                - Privacy verzoeken: binnen 72 uur conform GDPR
              </p>
            </div>
          </section>

          <section className="mb-8">
            <div className="bg-blue-50/60 rounded-lg p-6 border border-gray-200">
              <p className="text-sm text-[#475569]">
                <strong>Laatste update:</strong> 9 September 2025<br />
                <strong>Versie:</strong> 2.0 (Volledig geüpdateerd voor platformfunctionaliteiten)<br />
                <strong>Van kracht per:</strong> 9 September 2025<br /><br />

                Door gebruik te maken van het UGC4you platform accepteert u automatisch deze algemene voorwaarden. Deze voorwaarden zijn opgesteld conform Nederlandse wetgeving en bieden volledige juridische dekking voor alle platformfunctionaliteiten, betalingen, escrow systeem, GDPR compliance en geschillenresolutie.

              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}

export default TermsPage